import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["prefixCls", "inputId", "className", "checked", "defaultChecked", "disabled", "onChange", "tabIndex", "children", "large", "aria-labelledby", "showIndicator"];
import * as React from 'react';
import classNames from 'classnames';
import { useControlled, setupGetInstanceId, KEY_VALUES } from '../utils';
import { getText } from "../utils";
var getInstanceId = setupGetInstanceId();
var Switch = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _classNames;
  var _ref$prefixCls = _ref.prefixCls,
    prefixCls = _ref$prefixCls === void 0 ? 'ap-switch' : _ref$prefixCls,
    inputIdProp = _ref.inputId,
    className = _ref.className,
    checkedProp = _ref.checked,
    defaultChecked = _ref.defaultChecked,
    disabled = _ref.disabled,
    onChange = _ref.onChange,
    _ref$tabIndex = _ref.tabIndex,
    tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex,
    children = _ref.children,
    _ref$large = _ref.large,
    large = _ref$large === void 0 ? false : _ref$large,
    ariaLabelledBy = _ref['aria-labelledby'],
    showIndicator = _ref.showIndicator,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  var inputId = inputIdProp || "checkbox-" + getInstanceId();
  var _useControlled = useControlled(checkedProp, defaultChecked || false),
    checked = _useControlled[0],
    setChecked = _useControlled[1];
  function triggerChange(newChecked, event) {
    if (disabled) {
      return;
    }
    setChecked(newChecked);
    onChange === null || onChange === void 0 ? void 0 : onChange(newChecked, event);
  }
  function onInternalClick(e) {
    triggerChange(!checked, e);
  }
  var onKeyDown = function onKeyDown(event) {
    if (event.key === KEY_VALUES.ENTER || event.key === KEY_VALUES.SPACE) {
      triggerChange(!checked, event);
      event.preventDefault();
    }
  };
  var switchClassName = classNames(prefixCls + "-btn", (_classNames = {}, _classNames[prefixCls + "-checked"] = checked, _classNames[prefixCls + "-disabled"] = disabled, _classNames[prefixCls + "-lg"] = large, _classNames));
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref,
    className: classNames(prefixCls, className),
    onClick: onInternalClick,
    onKeyDown: onKeyDown
  }, restProps), /*#__PURE__*/React.createElement("button", {
    id: inputId,
    role: "switch",
    className: switchClassName,
    "aria-checked": checked,
    "aria-disabled": disabled,
    "aria-describedby": ariaLabelledBy,
    "aria-label": getText(children),
    disabled: disabled,
    tabIndex: tabIndex
    // @ts-ignore
    ,
    type: "button"
  }, /*#__PURE__*/React.createElement("span", {
    className: prefixCls + "-default"
  }, showIndicator ? /*#__PURE__*/React.createElement("div", {
    className: "ap-check-mark-container"
  }, /*#__PURE__*/React.createElement("svg", {
    width: "8px",
    height: "8px",
    viewBox: "0 0 8 8",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Toggle",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.09980431,8 C2.91193738,8 2.7553816,7.96540253 2.63013699,7.89620758 C2.50489237,7.82701264 2.37964775,7.71257485 2.25440313,7.55289421 L0.234833659,5.04590818 C0.0782778865,4.85429142 0,4.64404524 0,4.41516966 C0,4.18629408 0.0782778865,3.99201597 0.234833659,3.83233533 C0.391389432,3.67265469 0.57925636,3.59281437 0.798434442,3.59281437 C0.944553164,3.59281437 1.07240705,3.6247505 1.18199609,3.68862275 C1.29158513,3.75249501 1.39856491,3.84830339 1.50293542,3.9760479 L3.06849315,5.98802395 L6.46575342,0.463073852 C6.6431833,0.154357951 6.87801696,0 7.1702544,0 C7.38943249,0 7.58251794,0.0691949434 7.74951076,0.20758483 C7.91650359,0.345974717 8,0.532268796 8,0.766467066 C8,0.883566201 7.98173516,0.987358616 7.94520548,1.07784431 C7.9086758,1.16833001 7.85388128,1.27212242 7.78082192,1.38922156 L3.89823875,7.53692615 C3.69993477,7.84564205 3.43378995,8 3.09980431,8 Z",
    id: "Check",
    fillRule: "nonzero"
  })))) : "")), children !== undefined && /*#__PURE__*/React.createElement("label", {
    htmlFor: inputId,
    className: prefixCls + "-label",
    onClick: function onClick(e) {
      return e.preventDefault();
    },
    "aria-hidden": true
  }, children));
});
Switch.displayName = 'Switch';
export default Switch;